"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = __importDefault(require("react"));
const custom_cell_style_1 = __importDefault(require("../custom-cell.style"));
const button_1 = require("components/atoms/button");
const svg_1 = require("components/atoms/svg");
const typography_1 = require("components/atoms/typography");
const constants_1 = require("utils/constants");
const wsURL = process.env.WS_NESSLAB || '';
function customScanRfid(arg) {
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    return class CustomScanRfidClass extends react_1.default.Component {
        render() {
            const { dataItem, dataIndex } = this.props;
            const handleWebsocket = () => {
                //when click, create new websocket connection
                //when ws opened, send command START
                //when get message with command type READ, consume data, stop websocket
                console.log('scanning...');
                const ws = new WebSocket(wsURL);
                ws.onmessage = event => {
                    const data = JSON.parse(event.data);
                    if (data.command === 'READ') {
                        console.log(data);
                        const newDataItem = Object.assign(Object.assign({}, dataItem), { rfid_tag: data.data.hex_tag });
                        arg.onClick(newDataItem);
                    }
                    ws.send(JSON.stringify({ command: 'STOP' }));
                    ws.close();
                };
                ws.onopen = () => {
                    console.log('send command start');
                    ws.send(JSON.stringify({ command: 'START' }));
                };
            };
            return ((0, jsx_runtime_1.jsx)("td", Object.assign({ id: `${dataIndex}-${dataItem.id}` }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: custom_cell_style_1.default.rfidScanDeleteWrapper }, { children: [!dataItem.rfid_tag ? ((0, jsx_runtime_1.jsxs)(button_1.Button, Object.assign({ style: custom_cell_style_1.default.buttonSave(appTheme), onClick: handleWebsocket }, { children: [(0, jsx_runtime_1.jsx)(svg_1.ScanIcon, {}), (0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ style: custom_cell_style_1.default.btnStyle }, { children: "Scan" }))] }))) : ((0, jsx_runtime_1.jsxs)(button_1.Button, Object.assign({ style: custom_cell_style_1.default.buttonDelete(appTheme), onClick: () => {
                                const newDataItem = Object.assign(Object.assign({}, dataItem), { rfid_tag: '' });
                                arg.onClick(newDataItem);
                            } }, { children: [(0, jsx_runtime_1.jsx)(svg_1.DeleteIcon, { color: appTheme === 'dark' ? constants_1.color.black : constants_1.color.white }), (0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ style: custom_cell_style_1.default.btnStyle }, { children: "Delete" }))] }))), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: custom_cell_style_1.default.rfidTag }, { children: dataItem.rfid_tag }))] })) })));
        }
    };
}
exports.default = customScanRfid;
